export const iconFontAwesomeDevicesHardwareGamepad = (
	<i className="fa-solid fa-gamepad"></i>
);
